export default "__VITE_ASSET__IbnzWtNV__"